import React, {useEffect, useState} from 'react';
import styles from './index.module.scss'
import Footer from '../../components/footer'
import { MenuFoldOutlined } from '@ant-design/icons';
import NavbarMenus from "../../components/navbarMenus";
import Header from "../../components/header";
const Introduction = () => {
    return (
        <div className={styles.modules}>
            <div className={styles.navbar} id='nav'>
                <NavbarMenus path="Introduction"></NavbarMenus>
            </div>
            <div className={styles.view} id='chartView'>
                <Header title='介绍'></Header>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>McCharts是什么？
                    </div>
                    <p>
                        - McCharts(莓创图表)是McUI提供的一款开箱即用的图表工具库。组件库将会提供以下图表：折线图、柱状图、饼图、散点图、雷达图等等。
                    </p>
                    <p>
                        - McCharts 是从头开始创建的，专为Harmony OS的所有类型的开发人员而设计。而且我们开放了共创入口，集思广益，实现适应简单到复杂的各种业务场景。
                    </p>
                </div>
                <div className={styles.module} >
                    <div className={styles.title} id="aaaa">
                        <span>#</span>为什么选择McCharts？
                    </div>
                    <p>
                        - McCharts 是一款自研开发的公共组件，基于ArkTS最新版本。意味着HarmonyOS的新特性我们都支持，并拥有一个庞大的社区，您将拥有所有创建和制作项目的帮助和文档。
                    </p>
                    <p>
                        - 每个组件都是独立化的，更好的避免导入不必要的代码。
                    </p>
                    <p>
                        - 所有开发者拥有创建、改进和纠正任何组件或功能的开源社区。
                    </p>
                    <p>
                        - 提供了配套的设计资源，充分满足可定制化的需求。
                    </p>
                </div>
                <div className={styles.module}>
                    <div className={styles.title}>
                        <span>#</span>怎么运行的？
                    </div>
                    <p>
                        - McCharts 支持通过 ohpm 工具进行下载对应的依赖，运行于DevEco Studio 3.1.1+开发工具
                    </p>
                </div>
                <Footer></Footer>
            </div>
        </div>
    )
}

export default Introduction
